import { createContext, useContext } from 'react'
import type { Session } from '@supabase/supabase-js'

const VITE_CALLBACK_URL = import.meta.env.VITE_CALLBACK_URL

export type AuthUser = {
  id: string
  email: string
  username?: string
  user_metadata?: {
    full_name?: string
  }
} | null

export const AuthContext = createContext<{
  user: AuthUser
  session: Session | null
  signIn: (email: string, password: string) => Promise<void>
  signUp: (email: string, password: string) => Promise<void>
  signOut: () => Promise<void>
}>({
  user: null,
  session: null,
  signIn: async () => {},
  signUp: async () => {},
  signOut: async () => {}
})

export const useAuth = () => useContext(AuthContext)

export const OAUTH_REDIRECT_URL = VITE_CALLBACK_URL
